module.exports = __webpack_public_path__ + "img/log-in.a0e739ab.svg";